<template>
  <div>
    <app-header></app-header>
    <slot></slot>
  </div>
</template>
<script>
import Header from '@/components/main/Header'
// import index from './../projects/index'
export default {
  name: 'dashboard',
  components: {
    appHeader: Header
  },
  beforeCreate () {
    if (localStorage.locale) this.$i18n.locale = localStorage.locale
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/main.vue